/**
 * `useActionableSet` hook
 */
import * as React from "react"
import ActionableSetContext from "./ActionableSetContext"

const useActionableSet = () => React.useContext(ActionableSetContext)

export default useActionableSet
